import React, {useEffect, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import MeLoading from '../../components/loading'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Formik, Form, Field } from "formik";
import { BigButton } from '../../../../components/button'
import { changeAccountEmail, changeEmail } from '../../../../../api'
// import Toast from '../../../../components/toast'
import { isEmojiCharacter } from '../../../../../utils/common'
import NormalConfigConfirm from '../../../../components/alert/config-confirm'

const NewAccount = props => {
    useStyles(classes)
    const {Intl, onSubmit,} = props
    return (
        <div className={classes.NewAccount}>
            <Formik
                onSubmit={(e) => onSubmit(e)}
                initialValues={{
                    email: '',
                    password: '',
                }}
                validate={values => {
                    const errors = {}
                    const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

                    if(!values?.email){
                        errors.email = Intl.formatMessage({id: 'account_is_required'})
                    } else if(!emailReg.test(values?.email)){
                        errors.email = Intl.formatMessage({id: 'account_is_invalid'})
                    }

                    if(!values?.password){
                        errors.password =  Intl.formatMessage({id: 'fill_in_password'})
                    } else if(values?.password?.length < 6){
                        errors.password = Intl.formatMessage({id:"six_characters_min", defaultMessage:"6 characters minimum"});
                    } else if(values?.password?.length > 20){
                        errors.password = Intl.formatMessage({id:"twenty_characters_max", defaultMessage:"20 characters maximum"})
                    } else if(isEmojiCharacter(values?.password)){
                        errors.password = Intl.formatMessage({id:"no_emojis", defaultMessage:"No emojis"});
                    }

                    return errors
                }}
            >
                {
                    ({errors, touched}) =>(

                        <Form>
                            <div className={classes.FormItem}>
                                <label htmlFor="newAccountInput">{Intl.formatMessage({id: 'your_new_account', defaultMessage: 'Your New Account'})}</label>
                                <Field name="email">
                                    {({field, form: {touched, errors}, meta}) => (
                                        <div>
                                            <input id="newAccountInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                            {
                                                meta.touched && meta.error && (
                                                    <div className={classes.Errors}>{meta.error}</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </Field>
                            </div>

                            <div className={classes.FormItem}>
                                <label htmlFor="passwordInput">{Intl.formatMessage({id: 'password', defaultMessage: 'Password'})}</label>
                                <Field name="password">
                                    {({field, form: {touched, errors}, meta}) => (
                                        <div>
                                            <input id="passwordInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                            {
                                                meta.touched && meta.error && (
                                                    <div className={classes.Errors}>{meta.error}</div>
                                                )
                                            }
                                        </div>
                                    )}
                                </Field>
                            </div>


                            <div className={classes.SignOutButton}>
                                <BigButton style={{textTransform: 'capitalize'}} type="submit">
                                    {
                                        Intl.formatMessage({id: 'send_confirm_email', defaultMessage: 'Send a confirm Email'})
                                    }
                                </BigButton>
                            </div>
                        </Form>)
                }
            </Formik>
        </div>
    )
}

const ContactEmail = props => {
    useStyles(classes)
    const {communicationEmail, onSubmit, Intl} = props || {}

    return (
        <div className={classes.ContactEmail}>
            <Formik
                onSubmit={(e) => onSubmit(e)}
                initialValues={{
                    email: communicationEmail,
                }}
                validate={values => {
                    const errors = {}
                    const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

                    if(!values?.email){
                        errors.email = Intl.formatMessage({id: 'account_is_required'})
                    } else if(!emailReg.test(values?.email)){
                        errors.email = Intl.formatMessage({id: 'account_is_invalid'})
                    }

                    return errors
                }}
            >
                {
                    ({errors, touched}) =>(
                        <Form>
                            <div className={classes.FormItem}>
                                <label htmlFor="newAccountInput">{Intl.formatMessage({id: 'your_contact_email', defaultMessage:'Your contact / subscription address:'})}</label>
                                <div className={classes.ContactEmailLine}>
                                    <Field name="email">
                                        {({field, form: {touched, errors}, meta}) => (
                                            <div className={classes.ContactEmailLine}>
                                                <div>
                                                    <input id="newAccountInput" type="text" className={`${meta.touched && meta.error ? classes.ErrorInput: ''}`} {...field}/>
                                                    {
                                                        meta.touched && meta.error && (
                                                            <div className={classes.Errors}>{meta.error}</div>
                                                        )
                                                    }
                                                </div>
                                                <button type="submit">{Intl.formatMessage({id:'save', defaultMessage:'save'})}</button>
                                            </div>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </Form>)
                }
            </Formik>
        </div>
    )
}



const ChangeEmail = props => {
    useStyles(classes)

    const [loading, setLoading] = useState(false)
    const Intl = useIntl()
    // const global = useSelector(state => state.global)
    // const { user } = global || {}
    const pageCustomer = useSelector(state => state.pageCustomer);
    const { customer } = pageCustomer || {}
    const { communicationEmail, email } = customer || {}

    const onBack = () => {
        window.history.back()
    }

    const saveNewAccount = async (e) => {
        setLoading(true)
        let headers = {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        const response = await changeAccountEmail(e, headers)
        setLoading(false)
        if(response?.code == 200){
            // Toast(Intl.formatMessage({id: 'change_successful', defaultMessage: 'Change SuccessFul!'}))
            NormalConfigConfirm({
                message:{
                    text: Intl.formatMessage({ id: "check_mail_box", defaultMessage: "A verification link has been sent to your email address, please check your mailbox." }),
                },
                btn1:{
                    text: Intl.formatMessage({ id: "ok", defaultMessage: "OK" }),
                    clickHandle:()=>{
                        onBack()
                    }
                }
            });
        } else {
            alert(response?.result || Intl.formatMessage({id: 'change_failed', defaultMessage: 'Change Failed!'}))
        }
    }

    const saveContactEmail = async (e) => {
        setLoading(true)
        const response = await changeEmail(e)
        setLoading(false)
        if(response?.code == 200){
            NormalConfigConfirm({
                message:{
                    text: Intl.formatMessage({ id: "success_will_send_latest", defaultMessage: "Success! We will send our latest newsletter to your new email address." }),
                },
                btn1:{
                    text: Intl.formatMessage({ id: "ok", defaultMessage: "OK" }),
                    clickHandle:()=>{
                        onBack()
                    }
                }
            });
        } else {
            alert(response?.result || response)
        }
    }

    return <div className={classes.ChangeEmailPage}>
        <MeChildHeader name={Intl.formatMessage({id: 'change_email', defaultMessage: 'Change Email'})} onBack={() => onBack()}/>

        <NewAccount Intl={Intl} onSubmit={(e) => saveNewAccount(e)}/>

        {
            email ?
            <ContactEmail Intl={Intl} communicationEmail={communicationEmail} onSubmit={ (e) => saveContactEmail(e)}/>:
            <React.Fragment></React.Fragment>
        }

        <MeLoading loading={loading} />
    </div>
}

ChangeEmail.fetchData = async (store, params, search, headers) => {
    // await store.dispatch(action_get_credit_cards(headers))
}

export default ChangeEmail